var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',_vm._b({ref:"player",staticClass:"video-js",attrs:{"data-setup":"{}"}},'video',_vm.$attrs,false),[_c('p',{staticClass:"vjs-no-js"},[_vm._v(" 您的浏览器不支持 video 标签。 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }